import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TeamSection = () => {
  const teamMembers = [
   {
  id: 1,
  name: "Jasmeet Singh",
  role: [
  "Founder & Creative Director",
  "Digital Marketing Strategist",
  "Full-Stack Web Developer",
  "Flutter Developer"
],
  image: "https://cdn-icons-png.flaticon.com/512/9193/9193919.png",
  bio: "Visionary leader with 3+ years of experience in digital design and development. Passionate about creating meaningful digital experiences.",
  skills: [
    "UI/UX Design",
    "Flutter Development (iOS & Android)",
    "Full-Stack Web Development",
    "Digital Strategy & Transformation",
    "Social Media Marketing (SMO & SMM)",
    "Team Leadership & Client Relations"
  ],
  certifications: [
    "Google UX Design",
    "AWS Solutions Architect",
    "Scrum Master"
  ],
  linkedin: "https://linkedin.com/in/Jasmeetsingh",
  passion: "Photography & Mountain Climbing"
},
//     {
//   id: 2,
//   name: "Mehar Kaur",
//   // role: "Project Manager | Developer | Digital Marketing Strategist",
//   role: [
//   "Project Manager",
//   "Lead Developer",
//   "Digital Marketing Strategist"
// ],

//   image: "https://cdn-icons-png.flaticon.com/512/6997/6997662.png",
//   bio: "Versatile professional skilled in full-stack web development, mobile app development, and digital marketing strategy. Excels at leading projects, building scalable solutions, and driving growth through innovative digital campaigns.",
//   skills: ["React/Next.js", "Node.js", "Flutter", "iOS/Android", "Cloud Architecture", "DevOps", "Social Media Marketing", "Content Strategy"],
//   certifications: [
//     "AWS Certified Developer", 
//     "Google Cloud Professional", 
//     "MongoDB Certified", 
//     "Google Ads Certified", 
//     "Facebook Blueprint"
//   ],
//   linkedin: "https://linkedin.com/in/MeharKaur",
//   passion: "Open Source Contributions, AI Research & Digital Storytelling"
// }

   
   
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
              <Icon name="Users" size={24} className="text-white" />
            </div>
            <span className="text-accent font-semibold text-lg">Our Team</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Meet the Creative Minds
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            A diverse team of passionate professionals united by our commitment to digital excellence and client success.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {teamMembers?.map((member) => (
            <div key={member?.id} className="bg-white rounded-2xl p-6 brand-shadow brand-transition brand-hover-lift">
              {/* Profile Header */}
              <div className="text-center mb-6">
                <div className="relative inline-block mb-4">
                  <Image
                    src={member?.image}
                    alt={`${member?.name} - ${member?.role}`}
                    className="w-24 h-24 rounded-full object-cover mx-auto"
                  />
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-accent rounded-full flex items-center justify-center">
                    <Icon name="Star" size={16} className="text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-foreground mb-1">{member?.name}</h3>
                {/* <p className="text-accent font-semibold mb-3">{member?.role}</p> */}
                <div className="space-y-1 mb-3">
  {Array.isArray(member?.role) ? (
    member.role.map((r, idx) => (
      <p key={idx} className="text-accent font-semibold">{r}</p>
    ))
  ) : (
    <p className="text-accent font-semibold">{member?.role}</p>
  )}
</div>

                
                
                <p className="text-sm text-muted-foreground">{member?.bio}</p>
              </div>

              {/* Skills */}
              <div className="mb-6">
                <h4 className="text-sm font-semibold text-foreground mb-3">Core Skills</h4>
                <div className="flex flex-wrap gap-2">
                  {member?.skills?.map((skill, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              {/* Certifications */}
              <div className="mb-6">
                <h4 className="text-sm font-semibold text-foreground mb-3">Certifications</h4>
                <div className="space-y-2">
                  {member?.certifications?.map((cert, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <Icon name="Award" size={14} className="text-accent" />
                      <span className="text-xs text-muted-foreground">{cert}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Personal Touch */}
              <div className="mb-6 p-3 bg-surface rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Heart" size={16} className="text-accent" />
                  <span className="text-sm font-semibold text-foreground">Personal Passion</span>
                </div>
                <p className="text-sm text-muted-foreground">{member?.passion}</p>
              </div>

              {/* Connect Button */}
              {/* <a
                href={member?.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-primary text-white rounded-lg brand-transition hover:bg-primary/90"
              >
                <Icon name="Linkedin" size={18} />
                <span className="font-medium">Connect</span>
              </a> */}
            </div>
          ))}
        </div>

        {/* Team Stats */}
        <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            {/* <div>
              <div className="text-3xl font-bold mb-2">10+</div>
              <div className="text-white/80">Team Members</div>
            </div> */}
            {/* <div>
              <div className="text-3xl font-bold mb-2">25+</div>
              <div className="text-white/80">Combined Years Experience</div>
            </div> */}
            <div>
              <div className="text-3xl font-bold mb-2">5+</div>
              <div className="text-white/80">Professional Certifications</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">100%</div>
              <div className="text-white/80">Passion for Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;